import React from "react";
import Profile_sending from "./Axios.js";
import "./profile.css";
import StorageBox from "Store/StorageBox.js";
import { Friends } from "./friend/Friends.js";
import UserChecker from "Utility/UserChecker.js";

export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      isChristian: false,
      UserQuotes: "",
      UserBibleVerse: "",
      UserCountry: "Indonesia",
      UserEmail: "",
      UserReligion: "",
    };
  }

  setreligion(religionChecker) {
    return new Promise((resolve) => {
      this.setState({ isChristian: religionChecker }, resolve);
    });
  }
  async componentDidMount() {
    StorageBox.removePictureBackgroundProfile();

    // Use props.userData if available (viewing other user's profile), otherwise use StorageBox
    var item = this.props.userData || StorageBox.getUserData();
    console.log(
      "App.js - Using data:",
      this.props.userData ? "from props" : "from StorageBox",
      item
    );

    // Check religion from the viewed user's data, not from admin's StorageBox
    var userReligion = item.UserReligion || item.userReligion || "";
    var religionChecker = userReligion === "Christianity";
    console.log(
      "App.js - User religion:",  
      userReligion,
      "Is Christian:",
      religionChecker
    );

    await this.setreligion(religionChecker);

    if (this.state.isChristian) {
      document.getElementById("bible_verse").innerHTML =
        item.BibleVerse || item.bibleVerse || "";
    } else {
      document.getElementById("bible_verse").innerHTML =
        item.UserQuotes || item.userQuotes || "";
    }

    document.getElementById("highLight").innerHTML = item.UserIntroduction;
    document.getElementById("Username").innerHTML = item.UserName;
    document.getElementById("user_paragraph").innerHTML = item.UserParagraph;

    this.setState({ UserQuotes: item.UserQuotes });
    this.setState({ UserBibleVerse: item.BibleVerse });
    this.setState({ UserCountry: item.UserCountry });
    this.setState({ UserEmail: item.email });
    this.setState({ UserReligion: item.UserReligion });
  }

  render() {
    return (
      <div className="gird-cols-1 mb-12 grid gap-12 px-4 lg:grid-cols-2 xl:grid-cols-3">
        <div>
          <h6 className="text-blue-gray-900 mb-3 block font-sans text-base font-semibold leading-relaxed tracking-normal antialiased">
            {this.state.isChristian ? "Bible Verse" : "Favourite Quotes"}
          </h6>
          {this.state.isChristian ? (
            <div
              id="bible_verse"
              dangerouslySetInnerHTML={{ __html: this.state.UserBibleVerse }}
            />
          ) : (
            <div
              className="text-blue-gray-500 block font-sans text-sm font-normal leading-normal antialiased"
              id="bible_verse"
            >
              {this.state.UserQuotes}
            </div>
          )}
        </div>
        <div className="bg-transparent relative flex flex-col rounded-xl bg-clip-border text-gray-700 shadow-none">
          <div className="bg-transparent relative mx-0 mb-4 mt-0 flex items-center justify-between gap-4 overflow-hidden rounded-xl bg-clip-border text-gray-700 shadow-none">
            <h6 className="text-blue-gray-900 block font-sans text-base font-semibold leading-relaxed tracking-normal antialiased">
              Profile Information
            </h6>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
              className="text-blue-gray-500 h-4 w-4 cursor-pointer"
            >
              <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
            </svg>
          </div>
          <div className="p-0">
            <p
              className="text-blue-gray-500 block font-sans text-sm font-normal leading-normal antialiased"
              id="highLight"
            >
              {sessionStorage.getItem("i_highLight")}
            </p>
            <hr className="border-blue-gray-50 my-8" />
          </div>
        </div>
        <div>
          <div>
            <h6 className="text-blue-gray-900 mb-3 block font-sans text-base font-semibold leading-relaxed tracking-normal antialiased">
              Basic Information
            </h6>
            <ul className="flex flex-col gap-4 p-0">
              <li className="flex items-center gap-4">
                <p className="text-blue-gray-900 block font-sans text-sm font-semibold capitalize leading-normal antialiased">
                  Country:
                </p>
                <p className="text-blue-gray-500 block font-sans text-sm font-normal leading-normal antialiased">
                  {this.state.UserCountry}
                </p>
              </li>

              <li className="flex items-center gap-4">
                <p className="text-blue-gray-900 block font-sans text-sm font-semibold capitalize leading-normal antialiased">
                  Belief:
                </p>
                <p className="text-blue-gray-500 block font-sans text-sm font-normal leading-normal antialiased">
                  {this.state.UserReligion}
                </p>
              </li>
              <li className="flex items-center gap-4">
                <p className="text-blue-gray-900 block font-sans text-sm font-semibold capitalize leading-normal antialiased">
                  social:
                </p>
                <div className="flex items-center gap-4">
                  <a id="facebook" href="">
                    {" "}
                    <svg
                      className="fill-current text-blue-700"
                      xmlns="http://www.w3.org/2000/svg"
                      height="1em"
                      viewBox="0 0 320 512"
                    >
                      <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                    </svg>
                  </a>
                  <a id="twitter">
                    {" "}
                    <svg
                      className="fill-current text-blue-400"
                      xmlns="http://www.w3.org/2000/svg"
                      height="1em"
                      viewBox="0 0 512 512"
                    >
                      <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
                    </svg>
                  </a>
                  <svg
                    className="fill-current text-purple-500"
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 448 512"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                    <a href="#">Instagram</a>
                  </svg>
                </div>
              </li>
            </ul>
          </div>
          {
            // friend function not mature yet  <Friends />
          }
        </div>
      </div>
    );
  }
}
